import script from "./new-contact-type-lookup.vue?vue&type=script&setup=true&lang=ts"
export * from "./new-contact-type-lookup.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__